import React from 'react';
import Button from "react-bootstrap/Button";
const CLIENT_ID = "f0bb48553c39a2d19844";

function Homepage() {

    function loginWithGithub(){
        window.location.assign("https://github.com/login/oauth/authorize?client_id="+CLIENT_ID);
    }

    return (
        <>
            <main className="login-entry bg-gradient-to-r from-black to-green-500">
                <div>
                    <h1 className={"font-bold text-4xl mb-2"}>Welcome to the Memory Game!</h1>
                    <p>Get ready to match some cards and improve your memory!</p>
                </div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    fill="currentColor"
                    className="bi bi-github"
                    viewBox="0 0 16 16"
                    role="img"
                    aria-label="GitHub logo"
                >
                    <path
                        d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8"/>
                </svg>
                <button
                    aria-label="Login with GitHub"
                    className="bg-green-900 hover:bg-emerald-300 text-white font-bold py-2 px-4 border-b-4 border-green-600 hover:border-blue-500 rounded"
                    style={{width: "30%"}} onClick={loginWithGithub}>Login With GitHub
                </button>
            </main>

        </>
    );
}

export default Homepage;
